import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="tech-grid bg-blue-900 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-195" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-196" data-mp="2vqhhugko801z">
        <div className="text-center" data-id="element-197" data-mp="2vppm95r2q2bp">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-198" data-mp="2voo7aq6xsvop">
            ¿Te suena conocido esto?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-100" data-id="element-199" data-mp="35frca32zlut9">
            Domingo a las 11 de la noche. Mañana tienes clase de energía nuclear. Y todavía estás buscando cómo explicar
            la diferencia entre fisión y fusión, cómo funcionan los reactores o por qué la seguridad nuclear es
            importante sin que tus alumnos se duerman o no entiendan nada.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-slate-300" data-id="element-200" data-mp="1k52ak3szwhgo">
            No es tu culpa. Es que llevas años peleando con materiales desorganizados, teoría densa en libros viejos y
            recursos pensados para otros contextos que después tienes que reescribir entero.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-slate-300/25 bg-blue-950 p-6 sm:p-8" data-id="element-201" data-mp="x4i66tpxiaxy">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold tracking-tight text-white" data-id="element-202" data-mp="1c227nqnm9nzd">
            <AlertTriangleIcon className="h-5 w-5 text-slate-300" aria-hidden="true" data-id="element-203" data-mp="1g3w57q2imbvb" />
            El costo de no tener el material correcto:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-204" data-mp="3duyqhznrpuu1">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-100" data-id="element-205" data-mp="3hv96841d3zm3">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-500" aria-hidden="true" data-id="element-206" data-mp="p0sjzb0942u5" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-207" data-mp="y1qgz9c9va38">
          <p className="text-lg font-bold text-slate-200" data-id="element-208" data-mp="tzdagippb85e">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tienes. Ahora te falta la herramienta.
          </p>
          <p className="mt-3 text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-209" data-mp="17x1ujoby2b9e">
            Planifica todo tu año <span className="silver-text" data-id="element-210" data-mp="1hoy5hzz4pvv1">hoy.</span>
          </p>
        </div>
      </div>
    </section>;
}